<template>
  <Modal
    :show="show"
    :title="title"
    size="sm"
    role="alertdialog"
    :closable="!loading"
    :close-on-backdrop="false"
    :aria-describedby="messageId"
    @close="$emit('cancel')"
  >
    <p :id="messageId" class="text-sm text-neutral-600 dark:text-neutral-300 leading-relaxed">{{ message }}</p>

    <template #footer>
      <div class="flex items-center justify-end gap-2.5">
        <Button variant="secondary" size="sm" :disabled="loading" @click="$emit('cancel')">
          {{ cancelLabel }}
        </Button>
        <Button :variant="danger ? 'danger' : 'primary'" size="sm" :loading="loading" @click="$emit('confirm')">
          {{ confirmLabel }}
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/ui/Modal.vue'
import Button from '@/components/ui/Button.vue'

let uidCounter = 0

export default {
  name: 'ConfirmDialog',
  components: { Modal, Button },
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: 'Are you sure?' },
    message: { type: String, default: '' },
    confirmLabel: { type: String, default: 'Confirm' },
    cancelLabel: { type: String, default: 'Cancel' },
    danger: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
  },
  emits: ['confirm', 'cancel'],
  setup() {
    return { messageId: `confirm-message-${++uidCounter}` }
  },
}
</script>
